import script from "./LogoutConfirmModule.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutConfirmModule.vue?vue&type=script&setup=true&lang=js"

import "./LogoutConfirmModule.vue?vue&type=style&index=0&id=97a9fd00&lang=scss"

const __exports__ = script;

export default __exports__